import { ApiNamespaces, IQueuedRequest, OneAPIOptions } from '../../common'
import { AppCatalogApi } from './app'
import { BackofficeCatalogApi } from './backoffice'
import { Queue } from '../../queue'

export class Catalog implements ApiNamespaces {
  app: AppCatalogApi
  backoffice: BackofficeCatalogApi
  constructor(
    name: string,
    sessionId: string,
    requestsQueue: Queue<IQueuedRequest>,
    options?: OneAPIOptions
  ) {
    this.app = new AppCatalogApi(name, sessionId, requestsQueue, options)
    this.backoffice = new BackofficeCatalogApi(
      name,
      sessionId,
      requestsQueue,
      options
    )
  }

  invalidateAll() {
    this.app.invalidateAll()
    this.backoffice.invalidateAll()
  }
}
